var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cronometro",attrs:{"id":'cronometro'+_vm.idpedido}},[_c('p',[_vm._v(_vm._s(_vm.tempoRestante))])])}
var staticRenderFns = []

export { render, staticRenderFns }